<div *ngIf="validatePaymentGreaterThanBalance">
  <div class="width" *ngIf="!refundView">
    <div class="row d-flex justify-content-center pb-5 mb-5" style="margin: 0 1rem;">
      <div class="col-sm-12 col-md-5 gray-box">
        <h5>Plan Actual</h5>
        <div class="row">
          <div class="col">
            <p>Plan Nacional</p>
          </div>
          <div class="col">
            <h3 class="text-right">{{this.actualPrice | currency}}</h3>
          </div>
        </div>
        <h6>Descripción del Plan:</h6>
        <p>{{this.currentPlan}}</p>
      </div>
      <div class="col-sm-12 col-md-5 offset-md-1 white-box">
        <h5>Plan Seleccionado</h5>
        <div class="row">
          <div class="col">
            <p>Plan Nacional</p>
          </div>
          <div class="col">
            <h3 class="text-right roboto-b f-red">{{this.pricePlan | currency}}</h3>
          </div>
        </div>
        <h6>Descripcion del Plan:</h6>
        {{this.planToChange}} :
        <span *ngFor="let description of this.descriptions; let n = index">
        {{description.description}}
      </span>
        <p></p>
      </div>
    </div>
    <div class="row mb-5 d-flex justify-content-center align-items-center gray-panel" style="margin: 0 1rem">
      <div class="col text-center border-right py-3">
        <span class="roboto-b">Número de Teléfono</span><br/>
        <span class="f-big roboto-b">{{this.subscriber}}</span>
      </div>
      <div class="col text-center border-left py-3">
        <span class="roboto-b">Balance en Prepago Disponible</span><br/>
        <span class="f-lsemi roboto-b f-red">{{this.currentBalance | currency}}</span></div>
    </div>
    <div class="row d-flex justify-content-center ">
      <div class="row">
        <div class="col" style="margin: 0 1rem">
          <div class="d-flex align-items-center alert-snackbar justify-content-center mb-5">
            <mat-icon>info</mat-icon>
            <p class="m-0 small-snackbar">El plan seleccionado tiene un costo mayor a su balance disponible, por favor realice el pago
              de <b>{{ balanceToRecharge }}</b> para procesar su solicitud de cambio de plan. </p>
          </div>
        </div>
      </div>
      <div class="row mb-5 pb-5" style="margin: 0 1rem">
        <div class="col-12 d-flex justify-content-between amounts">
          <p>MONTO DE RECARGA</p>
          <p class="font-weight-bold">{{balanceToRecharge|currency}}</p>
        </div>
        <div class="col-12 d-flex justify-content-between amounts">
          <p>IVU</p>
          <p class="font-weight-bold">{{IVU|currency}}</p>
        </div>
        <div class="col">
          <div class=" roboto-b f-bmed text-center mb-3">
            CANTIDAD A PAGAR
          </div>
          <div class="d-flex justify-content-center">
            <button class="amount-to-recharge-active">
              <mat-icon class="mr-2">check_box</mat-icon>
              <p class="m-0">
                {{ balanceToRechargeFull | currency}}
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="m-top pb-3 button-area" ng-if="this.list.length > 0">
          <a (click)="this.backPage()" class="btns def-i gray pull-left vcenter">
            <span class="tabcell">
              <i class="fa fa-angle-left" aria-hidden="true"></i>&nbsp;&nbsp;Regresar
            </span>
          </a>
          <button class="btns def-i pull-right red vcenter" (click)="rechargeDiff()">
            <span class="tabcell pl-4">
              Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center" *ngIf="refundView">
    <div class="text-center">
      <h2 class="title-recharge">Aviso <img src="../../../../assets/images/claro-lines.png" class="img" alt=""></h2>
      <p>Estimado cliente al momento estamos presentando problemas para activacion de su nuevo plan.</p>
      <p class="m-0"><b>El balance de su recarga y los cargos asociados a su pago se encuentran en proceso de devolucion.</b></p>
      <p class="mb-4">Por favor verifique en las proximas horas.</p>
      <div class="d-flex justify-content-center mb-5">
        <button class="button-ok" (click)="return()">
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
